import { privateApi } from '@shared/config/axios.config';

interface GetNotesByLessonParams {
  lessonId: string;
}

export const getNotesByLessonApi = (params: GetNotesByLessonParams) => {
  return privateApi.get(`/account/notes/lesson/${params.lessonId}`);
};

interface RemoveNoteParams {
  id: string;
}

export const removeNoteApi = (params: RemoveNoteParams) => {
  return privateApi.delete(`/account/notes/${params.id}`);
};
